<template>
  <div class="flex flex-col items-center w-full px-4 py-4 text-sm text-gray-500 justify-center mx-auto">
    <div class="flex items-center justify-between space-x-2">
      <button type="button" class="hover:text-gray-600" v-if="paginate.hasPreviousPage"
              @click="listar(authToken, paginate.page-1, ...optionalParams);">Anterior
      </button>
      <div class="flex flex-row space-x-1">
        <button type="button"
                :class="'flex px-2 py-px '+(paginate.page===page?'text-white bg-blue-400 border border-blue-400':'border border-blue-400 hover:bg-blue-400 hover:text-white')"
                v-for="(page, index) in paginate.pageCount" :key="index"
                @click="listar(authToken, page, ...optionalParams);">
          {{ page }}
        </button>
      </div>
      <button type="button" class="hover:text-gray-600" v-if="paginate.hasNextPage"
              @click="listar(authToken, paginate.page+1, ...optionalParams);">Siguiente
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Componente de paginación.
 *
 * @component
 * @example
 * <PaginateComponent listar="listar" authToken="authToken" paginate="paginate" optionalParams="optionalParams" />
 *
 * @param {Function} listar - Función para listar los datos paginados.
 * @param {string} authToken - Token de autenticación del usuario.
 * @param {object} paginate - Objeto con la información de la paginación.
 * @param {number} paginate.page - Página actual.
 * @param {number} paginate.pageCount - Número total de páginas.
 * @param {boolean} paginate.hasPreviousPage - Indica si hay una página anterior a la actual.
 * @param {boolean} paginate.hasNextPage - Indica si hay una página siguiente a la actual.
 * @param {Array} optionalParams - Parámetros opcionales para la función de listar.
 *
 * @emits PaginateComponent#listar - Emite el evento para listar los datos paginados.
 */
export default {
  name: "PaginateComponent",
  props: ['listar', 'authToken', 'paginate', 'optionalParams']
};
</script>